module.exports = __webpack_public_path__ + "static/media/ntg55map.f7a8e99c.jpg";